(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ruru-gift-wrap"] && !Shopify.designMode) return;
  try {
    const RuruCartElement = customElements.get('cart-element');
  if (RuruCartElement && !RuruCartElement.prototype.ruruPairProductsGuard) {
    const renderPairProducts = RuruCartElement.prototype.renderPairProducts;
    RuruCartElement.prototype.renderPairProducts = function() {
      if (!document.querySelector('[data-pair-products]')) {
        this.flktyUpsell = null;
        return;
      }
      return renderPairProducts.call(this);
    };
    RuruCartElement.prototype.ruruPairProductsGuard = true;
  }

  if (!customElements.get('ruru-gift-wrap')) {
    customElements.define('ruru-gift-wrap', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-ruru-gift-toggle]');
        this.details = this.querySelector('[data-ruru-gift-details]');
        this.cards = [...this.querySelectorAll('[data-ruru-gift-card]')];
        this.message = this.querySelector('[data-ruru-gift-message]');
        this.blank = this.querySelector('[data-ruru-gift-blank]');
        this.count = this.querySelector('[data-ruru-gift-count]');
        this.notice = this.querySelector('[data-ruru-gift-notice]');
        this.status = this.querySelector('[data-ruru-gift-status]');
        this.preview = this.querySelector('[data-ruru-gift-preview]');
        this.previewImage = this.querySelector('[data-ruru-gift-preview-image]');
        this.previewText = this.querySelector('[data-ruru-gift-preview-text]');
        this.variantId = Number(this.dataset.variantId);
        this.productId = Number(this.dataset.productId);
        this.cardProperty = this.dataset.cardProperty;
        this.messageProperty = this.dataset.messageProperty;
        this.blankValue = this.dataset.blankValue;
        this.itemsLabelOne = this.dataset.itemsLabelOne;
        this.itemsLabelOther = this.dataset.itemsLabelOther;
        this.syncRun = 0;
        this.busy = false;
        this.saveTimer = null;

        this.toggle.addEventListener('change', () => this.onToggle());
        this.cards.forEach((card) => card.addEventListener('change', () => {
          this.refreshUi();
          this.scheduleSave(0);
        }));
        this.message.addEventListener('input', () => {
          this.refreshUi();
          this.scheduleSave(500);
        });
        this.blank.addEventListener('change', () => {
          if (this.blank.checked) this.message.value = '';
          this.message.disabled = this.blank.checked;
          this.refreshUi();
          this.scheduleSave(0);
        });

        /* Einmaliger Stopp vor der Kasse, wenn Karte oder Nachricht
           fehlt. Capture-Phase, damit der Theme-Handler nicht schon
           vorher abgeschickt hat. */
        this.onCheckoutAttempt = this.onCheckoutAttempt.bind(this);
        document.addEventListener('click', this.onCheckoutAttempt, true);
        document.addEventListener('submit', this.onCheckoutAttempt, true);

        this.cartObserver = new MutationObserver(() => this.sync());
        const itemsHolder = document.querySelector('#cartItemsHolder');
        if (itemsHolder) this.cartObserver.observe(itemsHolder, { childList: true });
        document.addEventListener('theme:cart:loaded', () => this.sync());
        this.renderVisibleCartCount(Number(this.dataset.visibleItemCount));
        this.sync();
      }

      disconnectedCallback() {
        if (this.cartObserver) this.cartObserver.disconnect();
        if (this.saveTimer) clearTimeout(this.saveTimer);
        document.removeEventListener('click', this.onCheckoutAttempt, true);
        document.removeEventListener('submit', this.onCheckoutAttempt, true);
      }

      root() {
        return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      }

      async getCart() {
        const response = await fetch(`${this.root()}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('cart');
        return response.json();
      }

      giftItems(cart) {
        return cart.items.filter((item) => Number(item.variant_id) === this.variantId || Number(item.product_id) === this.productId || item.sku === 'GIFT-WRAP');
      }

      giftCardItems(cart) {
        return cart.items.filter((item) => item.properties && item.properties._ruru_gift_card === 'true');
      }

      selectedCard() {
        return this.cards.find((card) => card.checked);
      }

      giftCardProperties() {
        return {
          _ruru_gift_card: 'true',
          _ruru_gift_wrap: String(this.variantId)
        };
      }

      readProperty(properties, names) {
        for (const name of names) {
          if (properties && properties[name]) return properties[name];
        }
        return '';
      }

      messageValue() {
        if (this.blank.checked) return this.blankValue;
        return this.message.value.trim();
      }

      properties() {
        const selected = this.selectedCard();
        return {
          [this.cardProperty]: selected ? selected.value : '',
          [this.messageProperty]: this.messageValue()
        };
      }

      /* Was der Kundschaft noch fehlt, bevor es sinnvoll zur Kasse
         geht: keine Karte gewaehlt, oder Karte ohne Nachricht und
         ohne bewusstes "leer lassen". */
      missing() {
        if (!this.toggle.checked) return '';
        if (!this.selectedCard()) return 'card';
        if (!this.blank.checked && this.message.value.trim() === '') return 'message';
        return '';
      }

      refreshUi() {
        const missing = this.missing();
        this.classList.toggle('is-missing-card', missing === 'card');

        if (missing === 'card') {
          this.notice.textContent = this.dataset.needCard;
          this.notice.hidden = false;
        } else if (missing === 'message') {
          this.notice.textContent = this.dataset.needMessage;
          this.notice.hidden = false;
        } else {
          this.notice.hidden = true;
          this.notice.classList.remove('is-flash');
        }

        this.updateCount();
        this.updatePreview();
      }

      updatePreview() {
        const selected = this.selectedCard();
        if (!this.toggle.checked || !selected) {
          this.preview.hidden = true;
          return;
        }
        this.preview.hidden = false;
        const image = selected.dataset.image;
        if (image && this.previewImage.getAttribute('src') !== image) {
          this.previewImage.setAttribute('src', image);
        }
        this.previewImage.setAttribute('alt', selected.value);

        const text = this.message.value.trim();
        if (this.blank.checked) {
          this.previewText.textContent = this.dataset.previewBlank;
          this.previewText.classList.add('is-placeholder');
        } else if (text === '') {
          this.previewText.textContent = this.dataset.previewEmpty;
          this.previewText.classList.add('is-placeholder');
        } else {
          this.previewText.textContent = this.message.value;
          this.previewText.classList.remove('is-placeholder');
        }
      }

      onCheckoutAttempt(event) {
        if (window.ruruGiftGatePassed) return;
        if (!this.toggle || !this.toggle.checked) return;

        if (event.type === 'submit') {
          const form = event.target;
          if (!form || !form.matches || !form.matches('[data-cart-form]')) return;
        } else {
          const trigger = event.target && event.target.closest ? event.target.closest('[name="checkout"], .cart__checkout') : null;
          if (!trigger) return;
        }
        if (!this.missing()) return;

        event.preventDefault();
        event.stopPropagation();
        window.ruruGiftGatePassed = true;
        this.refreshUi();
        this.notice.classList.add('is-flash');
        this.details.hidden = false;
        try {
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (error) {
          this.scrollIntoView();
        }
      }

      async sync() {
        if (this.busy) return;
        const run = ++this.syncRun;
        try {
          const cart = await this.getCart();
          if (run !== this.syncRun || this.busy) return;
          const gift = this.giftItems(cart)[0];
          const hasOtherItems = cart.items.some((item) => !this.giftItems({ items: [item] }).length && !this.giftCardItems({ items: [item] }).length);
          this.hideTechnicalLines(cart);
          this.updateVisibleCartCount(cart);
          this.classList.toggle('hidden', !gift && !hasOtherItems);
          this.toggle.checked = Boolean(gift);
          this.toggle.setAttribute('aria-expanded', String(Boolean(gift)));
          this.details.hidden = !gift;
          if (gift) {
            const cardName = this.readProperty(gift.properties, [this.cardProperty, 'Postkarte', 'Postcard']);
            const message = this.readProperty(gift.properties, [this.messageProperty, 'Persönliche Nachricht', 'Personal message']);
            if (cardName) {
              const selected = this.cards.find((card) => card.value === cardName);
              if (selected) selected.checked = true;
            }
            if (document.activeElement !== this.message) {
              if (message === this.blankValue) {
                this.blank.checked = true;
                this.message.value = '';
                this.message.disabled = true;
              } else {
                this.blank.checked = false;
                this.message.disabled = false;
                this.message.value = message;
              }
            }
          } else {
            window.ruruGiftGatePassed = false;
          }
          this.refreshUi();
          this.showError('');
        } catch (error) {
          this.showError(this.dataset.errorMessage);
        }
      }

      async request(path, body) {
        const response = await fetch(`${this.root()}cart/${path}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        if (!response.ok || data.errors) throw new Error('cart');
        return data;
      }

      async onToggle() {
        if (this.busy) return;
        this.syncRun += 1;
        if (this.saveTimer) clearTimeout(this.saveTimer);
        this.setBusy(true);
        this.showError('');
        let failed = false;
        try {
          const cart = await this.getCart();
          const gifts = this.giftItems(cart);
          const giftCards = this.giftCardItems(cart);
          if (this.toggle.checked) {
            /* Die Verpackung kommt auch ohne gewaehlte Karte in den
               Warenkorb. Die Karte folgt, sobald aktiv eine
               ausgesucht wurde. */
            const selected = this.selectedCard();
            const additions = [];
            if (gifts.length === 0) additions.push({ id: this.variantId, quantity: 1, properties: this.properties() });
            if (selected && giftCards.length === 0) {
              additions.push({ id: Number(selected.dataset.variantId), quantity: 1, properties: this.giftCardProperties() });
            }
            if (additions.length > 0) await this.request('add', { items: additions });
          } else if (gifts.length > 0 || giftCards.length > 0) {
            const updates = {};
            gifts.forEach((gift) => { updates[gift.key] = 0; });
            giftCards.forEach((card) => { updates[card.key] = 0; });
            await this.request('update', { updates });
            window.ruruGiftGatePassed = false;
          }
          this.details.hidden = !this.toggle.checked;
          this.toggle.setAttribute('aria-expanded', String(this.toggle.checked));
          this.refreshThemeCart();
        } catch (error) {
          failed = true;
          this.showError(this.dataset.errorMessage);
        } finally {
          this.setBusy(false);
          if (!failed) await this.sync();
        }
      }

      scheduleSave(delay) {
        if (!this.toggle.checked || this.busy) return;
        if (this.saveTimer) clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => this.save(), delay);
      }

      async save() {
        if (this.busy || !this.toggle.checked) return;
        this.syncRun += 1;
        this.setBusy(true);
        this.showError('');
        let failed = false;
        try {
          const cart = await this.getCart();
          const gift = this.giftItems(cart)[0];
          if (!gift) return;
          const selected = this.selectedCard();
          const giftCards = this.giftCardItems(cart);
          await this.request('change', { id: gift.key, quantity: 1, properties: this.properties() });

          if (!selected) {
            /* Keine Karte gewaehlt: eventuell alte Kartenzeilen raus. */
            if (giftCards.length > 0) {
              const updates = {};
              giftCards.forEach((card) => { updates[card.key] = 0; });
              await this.request('update', { updates });
            }
          } else {
            const selectedVariantId = Number(selected.dataset.variantId);
            const matchingCard = giftCards.find((card) => Number(card.variant_id) === selectedVariantId);
            const removals = giftCards.filter((card) => !matchingCard || card.key !== matchingCard.key);
            if (removals.length > 0) {
              const updates = {};
              removals.forEach((card) => { updates[card.key] = 0; });
              await this.request('update', { updates });
            }
            if (!matchingCard) {
              await this.request('add', { items: [{ id: selectedVariantId, quantity: 1, properties: this.giftCardProperties() }] });
            }
          }
          this.refreshThemeCart();
        } catch (error) {
          failed = true;
          this.showError(this.dataset.errorMessage);
        } finally {
          this.setBusy(false);
          if (!failed) await this.sync();
        }
      }

      refreshThemeCart() {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }

      updateCount() {
        this.count.textContent = `${this.message.value.length}/120`;
      }

      updateVisibleCartCount(cart) {
        const technicalItems = [...this.giftItems(cart), ...this.giftCardItems(cart)];
        const technicalQuantity = technicalItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
        const visibleQuantity = Math.max(0, Number(cart.item_count || 0) - technicalQuantity);
        this.renderVisibleCartCount(visibleQuantity);
      }

      hideTechnicalLines(cart) {
        const keys = new Set([...this.giftItems(cart), ...this.giftCardItems(cart)].map((item) => item.key));
        document.querySelectorAll('[data-cart-item]').forEach((element) => {
          element.toggleAttribute('hidden', keys.has(element.dataset.item));
        });
      }

      renderVisibleCartCount(quantity) {
        const template = quantity === 1 ? this.itemsLabelOne : this.itemsLabelOther;
        const label = template.replace(quantity === 1 ? '1' : '999', String(quantity));
        document.querySelectorAll('[data-cart-items-qty]').forEach((element) => {
          element.textContent = label;
          element.classList.toggle('hidden', quantity === 0);
        });
      }

      setBusy(value) {
        this.busy = value;
        this.classList.toggle('is-busy', value);
        this.toggle.disabled = value;
        this.cards.forEach((card) => { card.disabled = value; });
        this.message.disabled = value || this.blank.checked;
        this.blank.disabled = value;
      }

      showError(message) {
        this.status.textContent = message;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
